import React, { useEffect, useRef, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { FallingLines } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import image3 from "../../assets/images/image3.jpg";
import image4 from "../../assets/images/image4.jpg";
import image5 from "../../assets/images/image5.jpg";
import image6 from "../../assets/images/image6.jpg";
import send from "../../assets/svg/send.svg";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import axios from "../../components/Hooks/axios";
import SmallHeader from "../../components/Small_Header/SmallHeader";
import { setIsOpenAds } from "../../redux/slices/AdsSlice";
import { setUserObject } from "../../redux/slices/authSlice";
import { setPollEnable } from "../../redux/slices/tempSlice";
import AdsApply from "../ADS/AdsApply/AdsApply";
import LiveIndex from "../Live/LiveIndex";
import PostWrapper from "../Post/PostWrapper";
import StoryWrapper from "../Stories/StoryWrapper";
import CustomPoll from "./CustomPoll";
import Post from "./Post";
import StoryItem from "./StoryItem";
import styles from "./index.module.scss";
import PostSuggestion from "../../components/Suggestion/PostSuggestion";
import PostSuggestion2 from "../../components/Suggestion2/PostSuggestion";
import MobileFooter from "../../components/MobileFooter/MobileFooter";
import story from "../../assets/svg/story.svg";
import DefaultProfilePic from "../../assets/images/user.png";

const Home = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { userId, user } = useSelector((state) => state.auth);
	const { pollObj } = useSelector((s) => s.temp);
	const { isOpen } = useSelector((s) => s.ads);

	const [StoryPopup, setStoryPopup] = useState(false);
	const [PostPopup, setPostPopup] = useState(false);
	const [LivePopup, setLivePopup] = useState(false);
	const [StoryData, setStoryData] = useState([]);
	const [storyLoading, setStoryLoading] = useState(false);
	const [offset, setOffset] = useState(0);
	const [caption, setCaption] = useState("");
	// Image ðŸ‘‡
	const [fileData, setFileData] = useState(null);
	const imageRef = useRef(null);
	// Image ðŸ‘†
	const [rel, setRel] = useState(0);
	const [ownStory, setOwnStory] = useState(null);
	const [ownRel, setOwnRel] = useState(0);
	const mainContainer = useRef(null);
	const homeLeftContainer = useRef(null);
	const [isScrollingDown, setIsScrollingDown] = useState(false); // Track if scrolling down
	const [lastScrollTop, setLastScrollTop] = useState(0); // Store the last scroll position
	const [isHidden, setIsHidden] = useState(false); // Track if header/footer should be hidden
	const timer = useRef(null); // Timer for delayed reappearance

	const responsive = {
		0: {
			items: 2,
		},
		500: {
			items: 4,
		},
		600: {
			items: 5,
		},
		700: {
			items: 6,
		},
		800: {
			items: 7,
		},
		1024: {
			items: 8,
		},
	};

	const sidebarResponsive = {
		0: {
			items: 2,
		},
		1200: {
			items: 3,
		},
		1400: {
			items: 4,
		},
		1600: {
			items: 5,
		},
	};

	// Refresh stories when returning to Home or after upload
	useEffect(() => {
		setRel(Math.random());
		setOwnRel(Math.random());

		if (location.state?.storyUploaded) {
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.pathname]);

	// Guard: Redirect to interest page if user hasn't selected interests
	useEffect(() => {
		if (user && (!user.interestName || user.interestName.length === 0)) {
			navigate("/interest", { replace: true });
		}
	}, [user, navigate]);

	useEffect(() => {
		if (!userId || userId === "") return;

		setStoryLoading(true);
		axios
			.get("/story/stories")
			.then(({ data }) => {
				setStoryLoading(false);

				const filtered = data.filter(
					(item) => {
						const currentId = (userId?._id || userId || "").toString().trim();
						const itemId = (item?.userId?._id || item?.userId || "").toString().trim();
						return currentId !== itemId;
					}
				);

				setStoryData(filtered);
			})
			.catch(({ response }) => {
				setStoryLoading(false);
				console.log(response);
			});
	}, [rel, userId]);

	useEffect(() => {
		if (userId === "") return;
		axios
			.get(`/story/mystory/${userId}`)
			.then(({ data }) => {
				if (data.status) {
					setOwnStory(data.data);
				}
			})
			.catch((e) => {
				console.log(e);
			});

		axios
			.get(`/auth/get-user-details/${userId}`)
			.then(({ data }) => {
				dispatch(setUserObject(data));
			})
			.catch((e) => {
				console.log(e);
			});
	}, [userId, ownRel]);

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
	const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth < 480);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
			setIsSmallMobile(window.innerWidth < 480);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		const container = homeLeftContainer.current;

		const handleScroll = () => {
			const currentScrollTop = container.scrollTop;

			// Check if scrolling down
			if (currentScrollTop > lastScrollTop) {
				setIsHidden(true); // Hide header/footer when scrolling down
			} else if (currentScrollTop < lastScrollTop - 20) {
				setIsHidden(false); // Show header/footer when scrolling up
			}

			// Clear any existing timer
			if (timer.current) {
				clearTimeout(timer.current);
			}

			// Set a timer to show header/footer after a delay
			// timer.current = setTimeout(() => {
			// 	setIsHidden(false);
			// }, 1000); // Adjust delay as needed

			// Update the last scroll position
			setLastScrollTop(currentScrollTop);
		};

		if (container) {
			container.addEventListener("scroll", handleScroll);
		}

		return () => {
			if (container) {
				container.removeEventListener("scroll", handleScroll);
			}
		};
	}, [lastScrollTop]);

	return (
		<div className="App">
			<div className="MainContainer">
				<ScrollToTop />

				<div className={`${styles.Header} ${isHidden ? styles.Headerhidden : styles.HeaderShow}`}>
					<Header />
				</div>

				{isMobile && (
					<div className={`${styles.MobileFooter} ${isHidden ? styles.Footerhidden : styles.FooterShow}`}>
						<MobileFooter />
					</div>
				)}

				{/* NOTE: Custom Poll Popup ðŸ‘‡ */}
				{pollObj.customPollPopupShow && <CustomPoll />}
				{/* NOTE: Live ðŸ‘‡ */}
				{LivePopup && <LiveIndex setLivePopup={setLivePopup} />}
				{isOpen && <AdsApply />}


				<div className={`${styles.Container} ${styles.Home}`}>
					{/* <SmallHeader /> */}

					<div className={styles.homeContainer} ref={mainContainer}>
						{/* <div
							className={styles.sliderContainer}
							style={isMobile ? null : { marginTop: StoryPopup || PostPopup ? "-20rem" : "0rem" }}>
							<div className={`${styles["slide-wrapper"]} ${styles.cl}`}>
								<div
									className={styles["slider-item"]}
									onClick={() => {
										if (ownStory?.stories.length === 0) toast.info("You have no Story please add a Story !");
										else navigate(`/Story/${userId}`, { state: { own: true } });
									}}>
									<div className={styles.image}>
										{ownStory?.stories?.length === 0 ? (
											<img src={user?.ProfilePic} />
										) : (
											ownStory?.stories[ownStory?.stories?.length - 1]?.mediaType === "image" && (
												<img src={Array.isArray(ownStory?.stories[ownStory?.stories?.length - 1]?.mediaUrl) 
													? (typeof ownStory.stories[ownStory.stories.length - 1].mediaUrl[0] === 'string' ? ownStory.stories[ownStory.stories.length - 1].mediaUrl[0] : ownStory.stories[ownStory.stories.length - 1].mediaUrl[0]?.url) 
													: ownStory?.stories[ownStory?.stories?.length - 1]?.mediaUrl} />
											)
										)}
									</div>
									<div
										className={styles.Plus}
										onClick={(e) => {
											e.stopPropagation();
											setStoryPopup(true);
											setPostPopup(false);
											// homeLeftContainer.current.scrollTop = 183;
										}}>
										+
									</div>
								</div>
							</div>

							{storyLoading ? (
								<div className={styles.loaderContainer}>
									<FallingLines color="#A6539D" width="100" visible={true} ariaLabel="falling-lines-loading" />
								</div>
							) : (
								<div className={styles.customSlick}>
									<AliceCarousel
										mouseTracking
										disableButtonsControls
										disableDotsControls
										autoWidth>
										{StoryData?.map((data, index) => (
											<StoryItem key={index} data={data} />
										))}
									</AliceCarousel>
								</div>
							)}
						</div> */}

						<div className={styles.imagesMainContainer}>
							{/* {isMobile && (
								<div className={styles.homeRightContainer}>
									<div className={styles.storesContainer}>
										<div
											className={styles.sliderContainer}
											// style={{ marginTop: StoryPopup || PostPopup ? "-20rem" : "0rem" }}
										>
											<div className={`${styles["slide-wrapper"]} ${styles.cl}`}>
												<div
													className={styles["slider-item"]}
													onClick={() => {
														if (ownStory?.stories.length === 0)
															toast.info("You have no Story please add a Story !");
														else navigate(`/Story/${userId}`, { state: { own: true } });
													}}>
													<div className={styles.image}>
														{ownStory?.stories?.length === 0 ? (
															<img src={user?.ProfilePic} />
														) : (
															ownStory?.stories[ownStory?.stories?.length - 1]?.mediaType ===
																"image" && (
																<img
																	src={
																		ownStory?.stories[ownStory?.stories?.length - 1]?.mediaUrl
																	}
																/>
															)
														)}
													</div>
													<div
														className={styles.Plus}
														onClick={(e) => {
															e.stopPropagation();
															setStoryPopup(true);
															setPostPopup(false);
															navigate("/UploadStories");
															// homeLeftContainer.current.scrollTop = 183;
														}}>
														+
													</div>
													{isMobile ? <span className={styles.title}>Create</span> : null}
												</div>
											</div>

											{storyLoading ? (
												<div className={styles.loaderContainer}>
													<FallingLines
														color="#A6539D"
														width="100"
														visible={true}
														ariaLabel="falling-lines-loading"
													/>
												</div>
											) : (
												<div className={styles.customSlick}>
													<AliceCarousel
														mouseTracking
														disableButtonsControls
														disableDotsControls
														autoWidth>
														{StoryData?.map((data, index) => (
															<StoryItem key={index} data={data} />
														))}
													</AliceCarousel>
												</div>
											)}
										</div>
									</div>
								</div>
							)} */}
							<div
								className={styles.homeLeftContainer}
								ref={homeLeftContainer}
								onScroll={(e) => {
									// console.log(mainContainer.current.scrollTop);
									mainContainer.current.scrollTop = e.target.scrollTop;
									if (e.target.scrollHeight - e.target.scrollTop - 1 <= e.target.clientHeight)
										setOffset(offset + 10);
								}}>
								{/* <div className={styles.TopPadding}></div> */}
								{isMobile && (
									<div className={styles.homeRightContainer}>
										<div className={styles.storesContainer}>
											<div className={styles.Top}>
												<h3>fameo</h3>
												<button
													onClick={() => {
														if (StoryData && StoryData.length > 0) {
															navigate(`/Story/${StoryData[0].userId._id || StoryData[0].userId}`, {
																state: { watchAll: true, own: false },
															});
														} else {
															toast.info("No stories available to watch!");
														}
													}}>
													Watch all
												</button>
											</div>
											<div
												className={styles.sliderContainer}
											>
												<div className={`${styles["slide-wrapper"]} ${styles.cl}`}>
													<div
														className={styles["slider-item"]}
														onClick={() => {
															if (ownStory?.stories.length === 0)
																toast.info("You have no Story please add a Story !");
															else navigate(`/Story/${userId}`, { state: { own: true } });
														}}>
														{(() => {
															const lastStory = ownStory?.stories?.[ownStory.stories.length - 1];
															const mediaUrl = lastStory?.mediaUrl;
															const resolvedUrl = Array.isArray(mediaUrl)
																? (typeof mediaUrl[0] === 'string' ? mediaUrl[0] : mediaUrl[0]?.url)
																: (typeof mediaUrl === 'object' ? mediaUrl?.url : mediaUrl);

															const displayUrl = (ownStory?.stories?.length > 0 && resolvedUrl)
																? resolvedUrl
																: (user?.ProfilePic || DefaultProfilePic);

															return (
																<div
																	className={styles.storyMask}
																	style={{
																		WebkitMaskImage: `url(${story})`,
																		maskImage: `url(${story})`,
																	}}
																>
																	<img
																		src={displayUrl}
																		alt="My Story"
																		className={styles.storyImage}
																		onError={(e) => { e.target.src = DefaultProfilePic; }}
																		style={{
																			WebkitMaskImage: `url(${story})`,
																			maskImage: `url(${story})`,
																		}}
																	/>
																</div>
															);
														})()}
														<div
															className={styles.Plus}
															onClick={(e) => {
																e.stopPropagation();
																setStoryPopup(true);
																setPostPopup(false);
																navigate("/UploadStories");
																// homeLeftContainer.current.scrollTop = 183;
															}}>
															+
														</div>
														<span className={styles.title}>Create</span>
													</div>
												</div>

												{storyLoading ? (
													<div className={styles.loaderContainer}>
														<FallingLines
															color="#A6539D"
															width="100"
															visible={true}
															ariaLabel="falling-lines-loading"
														/>
													</div>
												) : (
													<div className={styles.customSlick}>
														<AliceCarousel
															mouseTracking
															disableButtonsControls
															disableDotsControls
															autoWidth>
															{StoryData?.map((data, index) => (
																<StoryItem key={index} data={data} />
															))}
														</AliceCarousel>
													</div>
												)}
											</div>
										</div>
									</div>
								)}
								{/* {StoryPopup && !PostPopup && <StoryWrapper {...{ setStoryPopup, setOwnRel }} />} */}
								{/* {PostPopup && !StoryPopup && <PostWrapper {...{ setPostPopup, fileData, setFileData }} />} */}
								{/* {!StoryPopup && !PostPopup && <Post {...{ offset, setOffset }} />} */}
								<Post {...{ offset, setOffset }} />
							</div>

							{isMobile ? null : (
								<div className={styles.homeRightContainer}>
									{/*
									 <div className={styles.messageBox}>
										<div className={styles.searchSection2}>
											<form>
												<input
													type="text"
													placeholder="Type something"
													value={caption}
													onChange={(e) => setCaption(e.target.value)}
													onClick={() => {
														setStoryPopup(false);
														setPostPopup(true);
													}}
												/>
												<button
													type="button"
													onClick={() => {
														// if (caption === "") toast.warn("Please Add Text!");
														// else navigate("/UploadPost", { state: { fileData, caption, fileType: "" } });
														setStoryPopup(false);
														setPostPopup(true);
													}}>
													<img src={send} />
												</button>
											</form>

											<ul>
												<input
													type="file"
													ref={imageRef}
													accept="image/*, video/*"
													style={{ display: "none" }}
													onChange={(e) => {
														setFileData(e.target.files[0]);
														setStoryPopup(false);
														setPostPopup(true);
														e.target.value = null;
													}}
												/>
												<li onClick={() => imageRef?.current?.click()}>Image</li>

												<li onClick={() => imageRef.current.click()}>Video</li>

												<li
													onClick={() => {
														setStoryPopup(false);
														setPostPopup(true);
														dispatch(setPollEnable(true));
														// setShowCustomPoll(true);
														// navigate("/UploadPost");
													}}>
													Poll
												</li>
												<li onClick={() => setLivePopup(true)}>Stream</li>
											</ul>
										</div>

										<div className={styles.ProgressBar}>
											<span style={{ width: `0%` }}></span>
										</div>
									</div> 
									*/}

									<div className={styles.storesContainer}>
										<div className={styles.Top}>
											<h3>fameo</h3>
											<button
												onClick={() => {
													if (StoryData && StoryData.length > 0) {
														navigate(`/Story/${StoryData[0].userId._id}`, {
															state: { watchAll: true, own: false },
														});
													} else {
														toast.info("No stories available to watch!");
													}
												}}>
												Watch all
											</button>
										</div>
										<div
											className={styles.sliderContainer}
										// style={{ marginTop: StoryPopup || PostPopup ? "-20rem" : "0rem" }}
										>
											<div className={`${styles["slide-wrapper"]} ${styles.cl}`}>
												<div
													className={styles["slider-item"]}
													onClick={() => {
														if (ownStory?.stories.length === 0)
															toast.info("You have no Story please add a Story !");
														else navigate(`/Story/${userId}`, { state: { own: true } });
													}}>
													{(() => {
														const lastStory = ownStory?.stories?.[ownStory.stories.length - 1];
														const mediaUrl = lastStory?.mediaUrl;
														const resolvedUrl = Array.isArray(mediaUrl)
															? (typeof mediaUrl[0] === 'string' ? mediaUrl[0] : mediaUrl[0]?.url)
															: (typeof mediaUrl === 'object' ? mediaUrl?.url : mediaUrl);

														const displayUrl = (ownStory?.stories?.length > 0 && resolvedUrl)
															? resolvedUrl
															: (user?.ProfilePic || DefaultProfilePic);

														return (
															<div
																className={styles.storyMask}
																style={{
																	WebkitMaskImage: `url(${story})`,
																	maskImage: `url(${story})`,
																}}
															>
																<img
																	src={displayUrl}
																	alt="My Story"
																	className={styles.storyImage}
																	onError={(e) => { e.target.src = DefaultProfilePic; }}
																	style={{
																		WebkitMaskImage: `url(${story})`,
																		maskImage: `url(${story})`,
																	}}
																/>
															</div>
														);
													})()}
													<div
														className={styles.Plus}
														onClick={(e) => {
															e.stopPropagation();
															setStoryPopup(true);
															setPostPopup(false);
															navigate("/UploadStories");
														}}>
														+
													</div>
													<span className={styles.title}>Create</span>
												</div>
											</div>

											{storyLoading ? (
												<div className={styles.loaderContainer}>
													<FallingLines
														color="#A6539D"
														width="100"
														visible={true}
														ariaLabel="falling-lines-loading"
													/>
												</div>
											) : (
												<div className={styles.customSlick}>
													<AliceCarousel
														mouseTracking
														disableButtonsControls
														disableDotsControls
														autoWidth>
														{StoryData?.map((data, index) => (
															<StoryItem key={index} data={data} />
														))}
													</AliceCarousel>
												</div>
											)}
										</div>
									</div>

									<h2>Ads & Blogs</h2>

									<div className={styles.staticImageContainer}>
										<div className={styles.AdsContainer}>
											<div
												className={styles.ImageWrapper}
												onClick={() => dispatch(setIsOpenAds({ isOpen: true, path: "home" }))}>
												<img src={image3} alt="image3" />
											</div>
											<p>
												Boost your brand visibility with high-impact ads and engaging blog content.
											</p>
										</div>
										{/* 
										<div className={styles.AdsContainer}>
											<div className={styles.ImageWrapper}>
												<img src={image4} alt="image4" />
											</div>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure autem quis eveniet.</p>
										</div>
										 */}
										<div className={styles.ImageWrapper}>
											<div className={styles.AdsContainer}>
												<div className={styles.ImageInner}>
													<img src={image5} alt="image5" />
												</div>
												<p>
													Reach the right audience, tell your
												</p>
											</div>
											<div className={styles.AdsContainer}>
												<div className={styles.ImageInner}>
													<img src={image6} alt="image6" />
												</div>
												<p>
													your story effectively, and turn
												</p>
											</div>
										</div>
									</div>

									<PostSuggestion2 />
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;

